























import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductItem } from '@/types';
import ProductRow from '@/components/ProductCategory/ProductRow/ProductRow.vue';
import ProductIconName from '@/components/Shared/ProductIconName';
import ProductSupportLink from '@/components/Shared/ProductSupportLink';
import ShowDetailsButton from '@/components/Shared/ShowDetailsButton';

@Component({
  components: {
    ProductRow,
    ProductIconName,
    ProductSupportLink,
    ShowDetailsButton,
  },
})
export default class ProductRowAccessories extends Vue {
  @Prop({ required: true }) public item: ProductItem;

  public getProductHistory(product: ProductItem) {
    this.$store.dispatch('fetchProductHistory', product);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProductCategory/ProductRow/ProductRowAccessories.vue